import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { EnvConfigService } from '../env-config/env-config.service';

export const apiUrlInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  if (!req.url.startsWith('/api/')) {
    return next(req);
  }

  const envConfigService = inject(EnvConfigService);
  const fullUrl = `${envConfigService.config().api.baseUrl}${req.url}`;

  return next(req.clone({ url: fullUrl }));
};
